var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGuterBrandEinbruchschutz = function SvgGuterBrandEinbruchschutz(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 71.94,
    height: 80.561
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__f",
    x1: 24.811,
    x2: 23.53,
    y1: 75.06,
    y2: 3.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.267,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.335,
    stopColor: "#f17011"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549,
    stopColor: "#f79f3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.739,
    stopColor: "#fbc15f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896,
    stopColor: "#fed673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__g",
    x1: 31.012,
    x2: 15.417,
    y1: 68.623,
    y2: 10.799,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e84b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#ef6001"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#f3811d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#fed564"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fed766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__j",
    x1: 44.546,
    x2: 32.65,
    y1: 40.742,
    y2: 53.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59797f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__k",
    x1: 37.348,
    x2: 30.58,
    y1: 35.336,
    y2: 53.576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__b",
    x1: 31.764,
    x2: 45.823,
    y1: 42.227,
    y2: 52.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4f4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f4f8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__b",
    id: "guter-brand-einbruchschutz_svg__l",
    x1: 34.54,
    x2: 42.192,
    y1: 37.793,
    y2: 43.831
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__c",
    x1: 9.814,
    x2: 18.414,
    y1: 38.09,
    y2: 39.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__m",
    x1: 57.049,
    x2: 62.31,
    y1: 46.3,
    y2: 47.071
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__n",
    x1: 28.888,
    x2: 46.379,
    y1: 39.784,
    y2: 42.347
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__o",
    x1: 15.117,
    x2: 31.79,
    y1: 38.158,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__p",
    x1: 41.991,
    x2: 56.291,
    y1: 43.07,
    y2: 45.165
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__q",
    x1: 44.2,
    x2: 36.448,
    y1: 76.33,
    y2: 16.747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.457,
    stopColor: "#ef6001",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.595,
    stopColor: "#f48b2b",
    stopOpacity: 0.363
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765,
    stopColor: "#fab856",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#fed370",
    stopOpacity: 0.132
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffdd7a",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__f",
    id: "guter-brand-einbruchschutz_svg__s",
    x1: 47.773,
    x2: 46.667,
    y1: 75.223,
    y2: 13.28
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__g",
    id: "guter-brand-einbruchschutz_svg__t",
    x1: 46.188,
    x2: 54.595,
    y1: 67.614,
    y2: 5.672
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__u",
    x1: 45.835,
    x2: 49.342,
    y1: 78.333,
    y2: 29.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e03616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ef6001"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__h",
    x1: 37.805,
    x2: 34.913,
    y1: 82.117,
    y2: 52.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bcc8cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a0b2b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__h",
    id: "guter-brand-einbruchschutz_svg__v",
    x1: 0.829,
    x2: 71.111,
    y1: 66.047,
    y2: 66.047
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "guter-brand-einbruchschutz_svg__i",
    x1: 26.352,
    x2: 33.446,
    y1: 67.54,
    y2: 61.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a0b2b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4c6f73"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__w",
    x1: 32.598,
    x2: 25.337,
    y1: 65.047,
    y2: 62.458
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__i",
    id: "guter-brand-einbruchschutz_svg__x",
    x1: 38.51,
    x2: 45.604,
    y1: 67.54,
    y2: 61.495
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#guter-brand-einbruchschutz_svg__c",
    id: "guter-brand-einbruchschutz_svg__y",
    x1: 44.756,
    x2: 37.495,
    y1: 65.047,
    y2: 62.458
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "guter-brand-einbruchschutz_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M59.404 35.382s2.948 17.674-5.575 21.493c3.158-8.034 2.11-21.68-5.063-32.17-9.7-12.662-7.273-22.251-7.273-22.251l-.46.287c-2.897 2.258-9.9 9.448-2.671 22.216 3.229 5.703 4.257 10.83 3.821 15.458-.658 7.012-4.68 12.875-9.507 17.846-.067.07-.125.145-.19.216-.299.317-.59.637-.862.97-.13.158-.243.324-.367.486-.194.255-.391.508-.57.77-.127.185-.238.376-.357.565-.156.247-.315.493-.457.746-.114.201-.215.407-.32.612-.128.246-.256.492-.37.742-.098.214-.185.43-.273.645-.102.247-.203.494-.293.744-.08.222-.15.445-.22.67q-.118.368-.22.74-.089.345-.164.69-.083.366-.148.734-.06.351-.106.702-.048.363-.078.725-.031.355-.046.708-.014.358-.01.713-.001.355.016.706c.012.235.034.466.057.698.024.234.047.468.081.7.034.227.08.452.125.677.045.23.088.46.145.687.056.221.126.437.193.655.068.223.131.447.211.665.079.217.174.426.265.637.09.211.172.425.273.63.107.218.233.427.353.638.106.19.203.383.32.566a13 13 0 0 0 1.792 2.21 42 42 0 0 0 6.319.631c6.926.178 13.74-2.897 19.084-7.673 11-9.823 15.782-26.84 2.545-37.484"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "guter-brand-einbruchschutz_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M22.624-2.546h49.798v88.093H22.624z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "guter-brand-einbruchschutz_svg__e",
    width: 49.92,
    height: 88.8,
    x: 22.509,
    y: -2.909,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#guter-brand-einbruchschutz_svg__a)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,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",
    width: 104,
    height: 185,
    transform: "matrix(.48 0 0 .48 22.509 -2.909)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "guter-brand-einbruchschutz_svg__r",
    width: 49.798,
    height: 88.093,
    x: 22.624,
    y: -2.546,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#guter-brand-einbruchschutz_svg__d)",
    opacity: 0.99
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#guter-brand-einbruchschutz_svg__a)",
    mask: "url(#guter-brand-einbruchschutz_svg__e)"
  }, /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGgAAAC5CAYAAADEfnorAAAACXBIWXMAABcRAAAXEQHKJvM/AAABvklEQVR4Xu3RoQEAIAzAMOD/n8cJSCoSXdc9M7PIOq+AvwyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoDiD4gyKMyjOoLgL6nUFbhixLPsAAAAASUVORK5CYII=",
    width: 104,
    height: 185,
    transform: "matrix(.48 0 0 .48 22.509 -2.909)"
  })))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ebene 2",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__f)",
    d: "M33.57 54.951c-7.134 7.352-7.947 18.696-1.413 25.066C12.021 76.405.687 59.908 4.522 35.724c1.674 6.7 1.304 10.792 10.048 18.977C8.176 42.074.91 23.37 29.993 0c-1.818 4.377-3.904 13.293 4.205 21.402a91.7 91.7 0 0 1 10.38 12.885c-.76 8.12-5.42 14.908-11.007 20.664"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__g)",
    d: "M33.572 54.951C27.13 62.057 25.755 72.216 31 78.741 13.48 75.019 3.845 61.239 4.89 41.916c1.06 3.996 2.857 7.81 8.974 13.536a1.03 1.03 0 0 0 .707.278 1.03 1.03 0 0 0 .915-1.493C12.074 47.493 9.045 40.073 10 31.494c.978-8.787 4.396-14.784 12.342-22.864a1.34 1.34 0 0 1 2.28.795c.505 3.778 3.98 7.083 8.849 12.704 3.104 3.585 9.662 9.927 10.105 14.132.155 1.48-.7 8.432-10.003 18.69"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcc8cc",
    d: "M38.1 80.56s13.223-11.187 17.956-16.788c6.755-7.985 10.12-32.16 8.15-42.416L38.102 14.2l-26.106 7.164c-1.969 10.248 1.395 34.423 8.15 42.408C24.878 69.373 38.1 80.561 38.1 80.561"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "M37.65 74.198c-3.983-3.49-11.104-9.863-14.05-13.338-4.87-5.76-8.278-24.616-7.548-35.438l.032-.485L38.1 18.893l22.017 6.036.033.485c.73 10.821-2.679 29.675-7.549 35.435-3.144 3.72-10.874 10.575-14.051 13.35l-.45.392Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#a0b2b6",
    d: "M38.1 73.684C33.56 69.704 26.93 63.73 24.123 60.42c-4.776-5.648-8.097-24.442-7.389-34.951l21.368-5.866 21.367 5.858c.709 10.509-2.616 29.303-7.388 34.948-2.81 3.325-9.437 9.31-13.98 13.276"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__j)",
    d: "M46.261 43.04h-1.418V39.99a6.746 6.746 0 0 0-13.485 0v3.051H29.94a1.22 1.22 0 0 0-1.22 1.219v9.989a1.22 1.22 0 0 0 1.22 1.22H46.26a1.22 1.22 0 0 0 1.22-1.22v-9.99a1.22 1.22 0 0 0-1.22-1.218m-3.669 0h-8.983V39.99a4.497 4.497 0 0 1 8.983 0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__k)",
    d: "M29.687 54.994v-9.989a1.22 1.22 0 0 1 1.22-1.218h1.419v-3.052a6.64 6.64 0 0 1 6.743-6.515 6.87 6.87 0 0 1 3.695 1.07 6.84 6.84 0 0 0-4.663-1.817 6.64 6.64 0 0 0-6.743 6.516v3.051H29.94a1.22 1.22 0 0 0-1.22 1.219v9.989a1.22 1.22 0 0 0 1.058 1.208 1.2 1.2 0 0 1-.091-.462"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__b)",
    d: "M38.1 33.846a6.266 6.266 0 0 1 6.369 6.143v3.424h1.792a.85.85 0 0 1 .847.847v9.987a.85.85 0 0 1-.847.848H29.94a.85.85 0 0 1-.848-.848V44.26a.85.85 0 0 1 .848-.847h1.791v-3.424a6.266 6.266 0 0 1 6.369-6.143m0-.374a6.64 6.64 0 0 0-6.742 6.517v3.05H29.94a1.22 1.22 0 0 0-1.22 1.22v9.988a1.22 1.22 0 0 0 1.22 1.22h16.32a1.22 1.22 0 0 0 1.221-1.22V44.26a1.22 1.22 0 0 0-1.22-1.22h-1.419v-3.051a6.64 6.64 0 0 0-6.741-6.517"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__l)",
    d: "M38.101 35.722a4.387 4.387 0 0 1 4.491 4.267v3.051h-8.983V39.99a4.39 4.39 0 0 1 4.492-4.267m0-.341a4.73 4.73 0 0 0-4.833 4.608v3.393h9.666v-3.393a4.73 4.73 0 0 0-4.832-4.608"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__c)",
    d: "M15.966 29.717a420 420 0 0 1-4.528-1.126 92.4 92.4 0 0 0 2.371 19.821q2.255-.656 4.403-1.125a90 90 0 0 1-2.246-17.57",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__m)",
    d: "M59.733 36.996a81.5 81.5 0 0 1-3.68 17.076 42 42 0 0 1 3.7 3.025 80.5 80.5 0 0 0 4.542-20.137 58 58 0 0 1-4.562.036",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#f4f4f8",
    d: "m24.262 61.611-.114-.126c-.194-.216-.38-.427-.547-.625-4.871-5.76-8.28-24.616-7.55-35.438l.033-.485 21.059-5.78-21.194 5.286-.351.097-.025.363-.032.484c-.736 10.914 2.727 29.96 7.668 35.804a51 51 0 0 0 4.548 3.988c-1.34-1.295-2.55-2.524-3.495-3.568"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__n)",
    d: "M46.968 43.268a1.2 1.2 0 0 0-.707-.229h-1.418v-3.05a6.3 6.3 0 0 0-1.018-3.413 311 311 0 0 1-9.863-1.71 6.6 6.6 0 0 0-1.377 1.388 6.33 6.33 0 0 0-1.227 3.735v3.05H29.94a1.22 1.22 0 0 0-1.22 1.22v.66a50 50 0 0 1 1.58-.027 45 45 0 0 1 17.182 3.278v-3.911a1.21 1.21 0 0 0-.514-.99m-4.376-.228h-8.983V39.99a4.07 4.07 0 0 1 .543-2.033 4.4 4.4 0 0 1 1.44-1.504 4.6 4.6 0 0 1 .763-.394 4.7 4.7 0 0 1 3.493 0 4.6 4.6 0 0 1 .763.394 4.4 4.4 0 0 1 1.438 1.504 4.1 4.1 0 0 1 .543 2.033Z",
    opacity: 0.5,
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__o)",
    d: "M28.72 44.259a1.22 1.22 0 0 1 1.22-1.22h1.418v-3.05a6.33 6.33 0 0 1 1.227-3.735 6.7 6.7 0 0 1 1.968-1.789c-6.651-1.265-12.967-2.692-17.877-3.874a91.3 91.3 0 0 0 2.057 15.891 58 58 0 0 1 9.986-1.221Z",
    style: {
      mixBlendMode: "soft-light"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__p)",
    d: "M43.413 36.002c.11.136.222.271.32.416a6.3 6.3 0 0 1 1.11 3.57v3.051h1.418a1.23 1.23 0 0 1 1.22 1.22v4.252a42.6 42.6 0 0 1 8.23 4.474 82.7 82.7 0 0 0 3.25-15.333 140 140 0 0 1-15.548-1.65",
    style: {
      mixBlendMode: "soft-light"
    }
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__q)",
    d: "M59.754 57.097a59 59 0 0 0 2.231-7.019l.002-.005q.318-1.247.602-2.532l.01-.05c.375-1.698.704-3.433.985-5.176l.015-.092q.202-1.263.369-2.523l.029-.22c.918-7.01 1.039-13.803.21-18.124L38.1 14.2l-26.106 7.164a45 45 0 0 0-.518 9.45l.003.093q.037 1.111.11 2.266l.013.204c.101 1.562.248 3.172.44 4.803l.013.117q.145 1.229.324 2.467l.016.104c.243 1.668.53 3.34.86 4.986l.02.097c1.49 7.386 3.836 14.236 6.869 17.821C24.878 69.373 38.1 80.561 38.1 80.561s13.222-11.188 17.955-16.789a24.5 24.5 0 0 0 3.698-6.675Z",
    opacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#guter-brand-einbruchschutz_svg__r)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__s)",
    d: "M56.86 72.866c-5.345 4.776-12.159 7.851-19.085 7.673a42 42 0 0 1-6.32-.63c-5.643-5.502-4.94-15.3 1.222-21.648 4.825-4.97 8.849-10.834 9.506-17.846.436-4.627-.592-9.755-3.821-15.458-7.229-12.768-.226-19.958 2.672-22.216q.227-.144.459-.287s-2.426 9.59 7.273 22.251c7.172 10.49 8.22 24.136 5.063 32.17 8.523-3.819 5.575-21.493 5.575-21.493 13.237 10.644 8.455 27.66-2.545 37.484"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__t)",
    d: "M56.268 72.203c-5.38 4.808-11.746 7.456-17.923 7.456q-.271 0-.548-.009a41 41 0 0 1-6.183-.616 35 35 0 0 1-1.158-.228c-4.53-5.635-3.549-14.602 2.222-20.545 4.622-4.76 8.969-10.42 10.39-17.763.98-5.069-.839-10.517-3.932-15.98-5.957-10.517-1.905-16.987 1.209-20.003-.178 3.659.545 11.362 7.7 20.711a38.6 38.6 0 0 1 6.244 16.602c.726 5.43.255 10.795-1.288 14.72a.89.89 0 0 0 .83 1.215.9.9 0 0 0 .36-.077c7.173-3.214 6.88-14.97 6.385-20.08a18.96 18.96 0 0 1 5.951 13.317c.193 7.415-3.643 15.372-10.259 21.28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__u)",
    d: "M39.136 24.518c3.093 5.463 4.912 10.911 3.931 15.98C41.647 47.84 37.3 53.5 32.677 58.26c-5.77 5.943-6.75 14.91-2.221 20.545q.572.123 1.158.228a41 41 0 0 0 6.183.616q.276.01.548.01c6.177 0 12.543-2.65 17.923-7.457 6.616-5.908 10.452-13.865 10.26-21.28 0 0-4.101 15.45-17.825 15.45s-1.764-13.822-.762-18.451c3.202-14.79-8.805-23.404-8.805-23.404",
    opacity: 0.99
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e03616",
    d: "M28.37 65.465a17.7 17.7 0 0 1 3.086-6.157c.717-.923 1.545-1.726 2.29-2.586a54 54 0 0 0 2.198-2.623 32.5 32.5 0 0 0 6.28-11.946 16.1 16.1 0 0 0 .56-6.647 26.2 26.2 0 0 0-1.801-6.515 40 40 0 0 0-1.42-3.105c-.513-1.013-1.091-2.018-1.566-3.075a20.3 20.3 0 0 1-1.811-6.646 21.6 21.6 0 0 0 2.204 6.458c.509 1.017 1.107 1.986 1.67 3a41 41 0 0 1 1.552 3.1 24.3 24.3 0 0 1 1.975 6.68 17 17 0 0 1-.505 6.978 32.1 32.1 0 0 1-6.61 12.147 54 54 0 0 1-2.315 2.573c-.79.845-1.637 1.62-2.366 2.481a18.5 18.5 0 0 0-3.42 5.883"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__h)",
    d: "M66.687 76.66a90.33 90.33 0 0 0-61.435 0A1.45 1.45 0 0 1 3.4 75.557L.073 63.687a1.796 1.796 0 0 1 .967-2.183 102.27 102.27 0 0 1 69.86 0 1.796 1.796 0 0 1 .967 2.182l-3.327 11.87a1.45 1.45 0 0 1-1.853 1.104"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__v)",
    d: "M67.132 75.778a.6.6 0 0 1-.2-.035 91.05 91.05 0 0 0-61.924 0 .6.6 0 0 1-.2.035.664.664 0 0 1-.62-.518L.862 63.39a.88.88 0 0 1 .042-.595.68.68 0 0 1 .382-.373 101.57 101.57 0 0 1 69.367 0 .68.68 0 0 1 .383.373.88.88 0 0 1 .042.595l-3.326 11.87a.665.665 0 0 1-.62.518"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__i)",
    d: "m30.137 59.053 1.316 2.667a.25.25 0 0 0 .19.138l2.944.428a.252.252 0 0 1 .14.43l-2.13 2.076a.25.25 0 0 0-.073.224l.503 2.931a.252.252 0 0 1-.366.266l-2.633-1.384a.25.25 0 0 0-.235 0l-2.632 1.384a.252.252 0 0 1-.367-.266l.503-2.931a.25.25 0 0 0-.072-.224l-2.13-2.076a.252.252 0 0 1 .14-.43l2.943-.428a.25.25 0 0 0 .19-.138l1.316-2.667a.252.252 0 0 1 .453 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__w)",
    d: "M29.91 58.912a.25.25 0 0 1 .227.141l1.316 2.667a.25.25 0 0 0 .19.138l2.944.428a.252.252 0 0 1 .14.43l-2.13 2.076a.25.25 0 0 0-.073.224l.503 2.931a.252.252 0 0 1-.366.266l-2.633-1.384a.25.25 0 0 0-.235 0l-2.632 1.384a.252.252 0 0 1-.367-.266l.503-2.931a.25.25 0 0 0-.072-.224l-2.13-2.076a.252.252 0 0 1 .14-.43l2.943-.428a.25.25 0 0 0 .19-.138l1.316-2.667a.25.25 0 0 1 .227-.14m0-.262a.51.51 0 0 0-.461.286l-1.316 2.667-2.937.423a.514.514 0 0 0-.285.877l2.13 2.076-.505 2.923a.513.513 0 0 0 .745.542l2.633-1.384 2.624 1.384a.514.514 0 0 0 .746-.542l-.503-2.931 2.127-2.068a.514.514 0 0 0-.285-.877l-2.943-.428-1.31-2.662a.51.51 0 0 0-.46-.286",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m26.983 68.201.503-2.931a.25.25 0 0 0-.073-.224l-.122-.119a.3.3 0 0 1 .006.089l-.503 2.931a.247.247 0 0 0 .192.282c0-.01-.005-.018-.003-.028M31.642 61.974a.25.25 0 0 0 .19.138l2.943.428c.008.001.012.007.02.009a.246.246 0 0 0-.209-.263l-2.943-.428a.3.3 0 0 1-.073-.03ZM25.423 62.54l2.943-.428a.25.25 0 0 0 .19-.138l1.317-2.667a.25.25 0 0 1 .334-.111l-.07-.143a.252.252 0 0 0-.453 0l-1.316 2.667a.25.25 0 0 1-.19.138l-2.943.428a.252.252 0 0 0-.14.43l.119.116a.25.25 0 0 1 .21-.292"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__x)",
    d: "m42.295 59.053 1.316 2.667a.25.25 0 0 0 .19.138l2.944.428a.252.252 0 0 1 .14.43l-2.13 2.076a.25.25 0 0 0-.073.224l.503 2.931a.252.252 0 0 1-.366.266l-2.633-1.384a.25.25 0 0 0-.235 0l-2.632 1.384a.252.252 0 0 1-.366-.266l.502-2.931a.25.25 0 0 0-.072-.224l-2.13-2.076a.252.252 0 0 1 .14-.43l2.943-.428a.25.25 0 0 0 .19-.138l1.317-2.667a.252.252 0 0 1 .452 0"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#guter-brand-einbruchschutz_svg__y)",
    d: "M42.069 58.912a.25.25 0 0 1 .226.141l1.316 2.667a.25.25 0 0 0 .19.138l2.944.428a.252.252 0 0 1 .14.43l-2.13 2.076a.25.25 0 0 0-.073.224l.503 2.931a.252.252 0 0 1-.366.266l-2.633-1.384a.25.25 0 0 0-.235 0l-2.632 1.384a.252.252 0 0 1-.366-.266l.502-2.931a.25.25 0 0 0-.072-.224l-2.13-2.076a.252.252 0 0 1 .14-.43l2.943-.428a.25.25 0 0 0 .19-.138l1.317-2.667a.25.25 0 0 1 .226-.14m0-.262a.51.51 0 0 0-.461.286l-1.316 2.667-2.937.423a.514.514 0 0 0-.284.877l2.13 2.076-.506 2.923a.513.513 0 0 0 .746.542l2.632-1.384 2.624 1.384a.514.514 0 0 0 .746-.542l-.503-2.931 2.127-2.068a.514.514 0 0 0-.285-.877L43.84 61.6l-1.31-2.662a.51.51 0 0 0-.46-.286",
    style: {
      mixBlendMode: "soft-light"
    }
  }), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#4c6f73",
    d: "m39.141 68.201.503-2.931a.25.25 0 0 0-.073-.224l-.122-.119a.3.3 0 0 1 .006.089l-.502 2.931a.247.247 0 0 0 .191.282c0-.01-.005-.018-.003-.028M43.8 61.974a.25.25 0 0 0 .19.138l2.943.428c.008.001.012.007.02.009a.246.246 0 0 0-.208-.263l-2.944-.428a.3.3 0 0 1-.073-.03ZM37.581 62.54l2.944-.428a.25.25 0 0 0 .19-.138l1.316-2.667a.25.25 0 0 1 .335-.111l-.07-.143a.252.252 0 0 0-.453 0l-1.317 2.667a.25.25 0 0 1-.19.138l-2.943.428a.252.252 0 0 0-.14.43l.119.116a.25.25 0 0 1 .21-.292"
  }))));
};
export default SvgGuterBrandEinbruchschutz;